export default __webpack_public_path__ + "static/media/p18.ac9e1b6a.jpg";